$(function() {
    let $icons = $(".icons-axis")

    function iconClick() {
        $icons.on('click', function(e){
            e.stopImmediatePropagation()

            let $this = $(this),
                $header = $this.next('.icon-title').find('h3')

            if($this.hasClass('highlight')){
                $this.removeClass('highlight')
                $header.removeClass('active')
            } else {
                $icons.removeClass('highlight')
                $icons.next('.icon-title').find('h3').removeClass('active')

                $this.addClass('highlight')
                $header.addClass('active')
            }
        })
    }

    if($icons.length > 0) {
        if(!Foundation.MediaQuery.atLeast('xlarge')) {
            iconClick()
        }

        $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
            if(newSize == 'small' || newSize == 'medium' || newSize == 'large') {
                iconClick()
            } else {
                $icons.removeClass('highlight')
                $icons.next('.icon-title').find('h3').removeClass('active')
            }
        })
    }
})